import { render, staticRenderFns } from "./PastBookings.vue?vue&type=template&id=008c2f97&"
import script from "./PastBookings.vue?vue&type=script&lang=js&"
export * from "./PastBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports